import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DoctorlicenseComponent } from './doctorlicense/doctorlicense.component';

const routes: Routes = [
  {path : 'dclicense',component:DoctorlicenseComponent}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LicenseIsuueRoutingModule { }
